import React from 'react'
import {
  Card,
  CardContent,
  Typography,
  Chip,
  Button,
  Box,
} from '@mui/material'
import dayjs from 'dayjs'
import { DivergenceData } from '../../DivergenceDemandsTypes'
import * as S from './DivergenceCard.styles'
import FreshIcon from 'src/assets/images/other-images/fresh.svg'
import GroceryIcon from 'src/assets/images/other-images/grocery.svg'

interface DivergenceCardProps {
  divergence: DivergenceData
  onClick?: () => void
}

const truncateText = (text: string, maxLength: number = 40): string => {
  if (text.length <= maxLength) return text
  return `${text.substring(0, maxLength)}...`
}

const getStatusColor = (status?: string): 'default' | 'warning' | 'success' | 'error' => {
  if (!status) return 'error'

  switch (status.toLowerCase()) {
    case 'criada':
      return 'warning'
    case 'em execução':
      return 'default'
    case 'finalizada':
      return 'success'
    default:
      return 'error'
  }
}

const getFloorIcon = (piso?: string) => {
  if (!piso) return null

  switch (piso) {
    case 'Fresh':
      return <img src={FreshIcon} alt='Fresh' width={16} height={16} />
    case 'Mercearia':
      return <img src={GroceryIcon} alt='Mercearia' width={16} height={16} />
    default:
      return null
  }
}

const DivergenceCard: React.FC<DivergenceCardProps> = ({ divergence, onClick }) => (
  <S.CardWrapper>
    <Card elevation={2} sx={{ height: '100%' }}>
      <CardContent>
        <S.Header>
          <Box>
            <Typography
              variant='h6'
              component='h3'
              fontWeight='bold'
              sx={{ marginBottom: '4px' }}
            >
              {divergence.codProd || 'Sem código'}
            </Typography>
            {divergence.descProd && (
              <S.ProductDescription title={divergence.descProd}>
                {truncateText(divergence.descProd, 50)}
              </S.ProductDescription>
            )}
          </Box>
          <Chip
            label={divergence.status || 'Sem status'}
            color={getStatusColor(divergence.status)}
            size='small'
          />
        </S.Header>

        <S.InfoRow>
          <S.InfoItem>
            <S.InfoLabel>Endereço</S.InfoLabel>
            <S.InfoValue>
              <Box display='flex' alignItems='center' gap={1}>
                {getFloorIcon(divergence.floor)}
                <span>{divergence.location || 'Não informado'}</span>
              </Box>
            </S.InfoValue>
          </S.InfoItem>
        </S.InfoRow>

        <S.InfoRow>
          <S.InfoItem>
            <S.InfoLabel>Tipo</S.InfoLabel>
            <S.InfoValue>{divergence.type || 'Não informado'}</S.InfoValue>
          </S.InfoItem>

          <S.InfoItem>
            <S.InfoLabel>Data</S.InfoLabel>
            <S.InfoValue>
              {divergence.date ? dayjs(divergence.date).format('DD/MM/YYYY') : 'Não informada'}
            </S.InfoValue>
          </S.InfoItem>
        </S.InfoRow>

        {['criada', 'em execução'].includes((divergence.status || '').toLowerCase()) && (
          <S.ActionButtonRow>
            <Button
              variant='contained'
              size='small'
              color='primary'
              onClick={() => {
                if (onClick) {
                  onClick()
                }
              }}
            >
              Iniciar
            </Button>
          </S.ActionButtonRow>
        )}
      </CardContent>
    </Card>
  </S.CardWrapper>
)

export default DivergenceCard
